<app-modal [isOpen]="(showModal$ | async) ?? false" [showCloseButton]="false" [className]="'max-w-md'" (close)="onClose()">
  <div class="text-center sm:text-left">
    <h3
      class="flex items-center justify-center gap-2 text-lg font-semibold leading-6 text-gray-900 dark:text-white sm:justify-start"
      id="modal-title">
      <i class="bi bi-exclamation-triangle-fill text-red-600 dark:text-red-500"></i>
      Session Revoked
    </h3>
    <div class="mt-2">
      <p class="text-sm text-gray-500 dark:text-gray-400">
        Your session has been revoked. Please log in again.
      </p>
    </div>
  </div>
  <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse gap-3">
    <button type="button" (click)="onBackToLogin()"
      class="inline-flex w-full justify-center rounded-lg bg-brand-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-brand-500 sm:w-auto">
      Back to Login Page
    </button>
  </div>
</app-modal>
